require('../../../common/directives/jv.root-modal.directive.js');
require('../../../common/directives/jv.HideOnBlur.js');
require('../../../common/directives/jv.common.switch.directive.js');
require('../../../common/directives/jv.HideOnBlur.js');

angular.module('jv.Admin.Users.Roles.Details.Controller', [
    'jv.common.root-modal.directive',
    'jv.Common.Directives.HideOnBlur',
    'jv.common.switch.directive',
    'jv.Common.Directives.HideOnBlur'
  ])
  .controller('jvAdminUsersRolesDetailsController', ['$scope', '$route', '$rootScope', 'jvAdminUsersRolesService', '$filter', '$location',  'jvAdminUsersRoleModalFactory', 'jvAdminUsersPermissionFactory',
    function($scope, $route, $rootScope, jvAdminUsersRolesService, $filter, $location, jvAdminUsersRoleModalFactory, jvAdminUsersPermissionFactory) {

    jvAdminUsersPermissionFactory.setPermissions();
    $scope.viewPermissions = jvAdminUsersPermissionFactory;

    $scope.breadcrumbsConfig = $route.current.locals.breadcrumbsResolve;
    $scope.showDisabledPermission = true;

    $scope.breadcrumbsConfig.links.unshift({
        linkText: i18n['ROLE_DETAIL_BREADCRUMB'],
    });

    $scope.modalService = jvAdminUsersRoleModalFactory;
    $scope.permissionGroupName = "General";
    $scope.filterArrowDown = false;
    
    $scope.toggleFiltersDropdown = function(){
        $scope.filterArrowDown = !$scope.filterArrowDown;
    };

    $scope.hideFiltersDropdown = function() {
        $scope.filterArrowDown = false;
    };

    var roleId = $scope.params.id;
    var roleRequestObject = {};
    var updatePermissions = {};
    roleRequestObject.roleId = roleId;

    var statusFilters = [{
        "value": "Active",
        "key": "true"
    }, {
        "value": "Inactive",
        "key": "false"
    }];

    var columns = [{
        fieldName: "Field Title",
    }, {
        fieldName: "Read",
    }, {
        fieldName: "Write",
    }];
    var state = $scope.state = {
        modals: {},
        permissionDomains: [],
        permissionCategories: [],
        updatedPermissions: {},
        editPermissions: false,
        collapsed: false,
        filterPermissionData: {},
        columns: columns,
        filterPermission: true,
        showEditButton: true,
        auditLog: {
            expand : true
        },
        queryData:{
            page: 0,
        },
        roleAuditLogs: {}
    };
    //This method will massage all the domain permissions to adapt to UI designs. 
    var massagePermissions = function(permissionDomain) {
        //Traverse through all permission categories
        angular.forEach(permissionDomain.permissionCategories, function(permissionCategory, key){
            //This will be used to collapse/expand each category
            permissionCategory.collapse = false;
            //Traverse through permissions within a category to set the selectedAccountable etc. 
            angular.forEach(permissionCategory.permissionTOs, function(permission, key){

                if (permission.accountableTOs && permission.accountableTOs.length > 0) {
                    angular.forEach(permission.accountableTOs, function(accountable, key) {
                        if (accountable.enable) {
                            permission.selectedAccountable = accountable;
                        }
                    });
                }
            });
        });
    };

    var massageDomains = function(permissionDomains) {
        angular.forEach(permissionDomains, function(domainValue, key) {
            var permissionDomain = {};
            permissionDomain.id = domainValue.domain;
            permissionDomain.label = domainValue.domainLabel;
            permissionDomain.permissionCategories = domainValue.categoryToPermissionsTOs;
            if (key === 0) {
                permissionDomain.selected = true;
            }
            massagePermissions(permissionDomain);
            state.permissionDomains.push(permissionDomain);
        });
        state.permissionDomains.push({
            id: 'CustomField',
            label: i18n.ADMIN_CUSTOM_FIELDS
        });
        state.permissionDomains.push({
            id: 'activityLog',
            label: i18n.ACTIVITY
        });
    };
   
    $scope.deleteRole = function() {
        return jvAdminUsersRolesService.deleteRole(angular.copy(roleRequestObject), function(data) {
            $scope.hideModals();
            $location.path('/users/roles/list');
        }, function() {
            $scope.hideModals();
            console.log("Error Deleting Role");
        });
    };
    $scope.cancelEditPermissions = function() {
        state.editPermissions = false;
        state.filterPermission = true;
        state.updatedPermissions = {};
        state.permissionCategories = angular.copy(state.permissionCategoriesCopy);
    };

    $scope.toggleActions = function() {
        $scope.actionDropDown = !$scope.actionDropDown;
    };

    $scope.editPermissions = function() {
        state.editPermissions = true;
        state.filterPermission = false;
        state.permissionCategoriesCopy = angular.copy(state.permissionCategories);
    };

    $scope.selectCustomFieldCategory = function(permCategory) {
        var domainObject = {};
        domainObject.id = "CustomField";
        $scope.selectPermissionDomain(domainObject, permCategory);
    };

    $scope.updatePermissionsRead = function(permissionCategory) {
        if (permissionCategory.fieldAccess[0].enabled === false) {
            permissionCategory.fieldAccess[1].enabled = false;
        }
        updatePermissions[permissionCategory.objectId] = angular.copy(permissionCategory);
    };

    $scope.updatePermissionsWrite = function(permissionCategory) {
        if (permissionCategory.fieldAccess[1].enabled) {
            permissionCategory.fieldAccess[0].enabled = true;
        }
        updatePermissions[permissionCategory.objectId] = angular.copy(permissionCategory);
    };

    $scope.showHiddenPermission = function(showDisabledPermission){
        if(showDisabledPermission){
            state.filterPermission = true;
        }else{
            state.filterPermission = false;
        }
    };

    $scope.selectPermissionDomain = function(domain, category) {
        var confirmation = false;
        if (state.editPermissions === true) {
            confirmation = confirm(i18n['CONFIRMATION_MSG']);
            if (confirmation === true) {
                $scope.cancelEditPermissions();
                selectPermissionDomainHelper(domain, category);
            }
        } else {
            selectPermissionDomainHelper(domain, category);
        }
    };

    var selectPermissionDomainHelper = function(domain, category) {
        var requestObject = {};
        requestObject.roleId = roleId;
        if (angular.isDefined(category)) {
            requestObject.category = category.categoryId;
        }
        state.selectedDomain = domain.id;
        state.permissionCategories = {};
        if (state.selectedDomain === "CustomField") {
            $scope.flags.loading = true;
            if(state.filterPermission === true){
                $scope.showDisabledPermission = true;
                state.filterPermission = true;
            }else{
                $scope.showDisabledPermission = false;
                state.filterPermission = false;
            }
            jvAdminUsersRolesService.getViewFieldsForRole(requestObject, function(data) {

                if (data && data.viewFieldPermissions) {
                    state.permissionCategories = data.viewFieldPermissions;
                    angular.forEach(state.permissionCategories, function(value, key){
                        if (value.viewFieldPermissionTOs && value.viewFieldPermissionTOs.length > 0) {
                            state.selectedPermissionCategory = value;
                        }
                    }); 
                }
                $scope.flags.loading = false;
            }, function() {
                $scope.flags.loading = false;
                $scope.$root.showMsg('UNABLE_TO_PERFORM_OPERATION', false, 'error');
            });
        } else {
            state.permissionCategories = domain.permissionCategories;
        }
        if(state.selectedDomain === 'activityLog') {
           jvAdminUsersRolesService.getAuditLog(requestObject, function(data){
                 if(data && data.roleAuditLogs){
                //loalizing auditLog verb using i18n token
                    angular.forEach(data.roleAuditLogs, function(auditLog) {
                        auditLog.verb = i18n[auditLog.verb];
                    });
                    state.total = data.count;
                    state.pageSize = data.pageCount;
                    state.roleAuditLogs = data.roleAuditLogs;
                }
            }, function() {
                $scope.$root.showMsg('UNABLE_TO_PERFORM_OPERATION', false, 'error');
            });
        }
        state.updatedPermissions = {};
        if (state.selectedDomain === 'activityLog') {
            state.showEditButton = false;
        } else {
            state.showEditButton = true;
        }
    };

    var convertPermission = function(permission) {
        var permissionResponse = {};
        permissionResponse.enable = permission.enable;
        permissionResponse.permissionKey = permission.code;
        permissionResponse.sId = permission.SId;
        if (permissionResponse.enable && permission.selectedAccountable) {
            permissionResponse.accountableKey = permission.selectedAccountable.key;
        }
        return permissionResponse;
        
    };
    

    var convertToResponse = function(role, updatedPermissions) {
        var response = {};
        var updatedPermissionsResponse = [];
        response.sId = role.SId;
        response.active = role.active;
        response.label = role.label;
        response.description = role.description;
        if (angular.isDefined(updatedPermissions)) {
            angular.forEach(updatedPermissions, function(permission, permissionKey){
               updatedPermissionsResponse.push(convertPermission(permission));
            });
        }
        response.updatedPermissions = updatedPermissionsResponse;
        return response;
    };

    $scope.updateRole = function() {
        $scope.flags.loading = true;
        return jvAdminUsersRolesService.updateRole(convertToResponse(state.role, state.updatedPermissions), function(data) {
            $scope.hideModals();
            state.editingTitle = false;
            state.editingDescription = false;
            $scope.flags.loading = false;
            state.editPermissions = false;
            state.updatedPermissions = {};
        }, function() {
            $scope.hideModals();
            $scope.flags.loading = false;
            state.editPermissions = false;
            state.updatedPermissions = {};
        });
    };

    $scope.savePermissions = function() {
        state.filterPermission = true;
        if (state.selectedDomain === 'CustomField') {
            $scope.saveViewFieldPermissions();
        } else {
            $scope.updateRole();
        }
    };

    $scope.saveViewFieldPermissions = function() {
        $scope.flags.loading = true;

        var updatePermissionResponse = [];
        angular.forEach(updatePermissions, function(value, key){
            updatePermissionResponse.push(value);
        });

        jvAdminUsersRolesService.saveViewFieldsForRole(updatePermissionResponse, function(data) {
            $scope.flags.loading = false;
            state.editPermissions = false;
            state.updatedPermissions = {};
            updatedPermissions = {};
        }, function() {
            $log.error("Failed to save view field permissions. ");
        });
    };

    $scope.updatePermissions = function(permission, accountableChanged) {
        //ERF-TODO: Ensure that only changed permissions show up. There is a scenario when you enabled/disabled/enabled something. it should potentially not be sent to the backend. 
        state.updatedPermissions[permission.SId] = permission;
        if (accountableChanged && permission.selectedAccountable) {
            var selectedAccountable = permission.selectedAccountable;
            angular.forEach(permission.accountableTOs, function(value, key){
                if (value.key === selectedAccountable.key) {
                    value.enable = true;
                } else {
                    value.enable = false;
                }
            });
        }
    };

    $scope.toggleActive = function() {
        if (state.role.active) {
            state.modals.inactivate = true;
        } else {
            state.modals.activate = true;
        }
    };

    $scope.hideModals = function() {
        state.modals = {};
    };

    $scope.expandAll = function() {
        angular.forEach(state.permissionCategories, function(permissionCategory, key) {
            permissionCategory.collapse = false;
        });
    };

    $scope.collapseAll = function() {
        angular.forEach(state.permissionCategories, function(permissionCategory, key) {
            permissionCategory.collapse = true;
        });
    };

    $scope.next = function() {
        state.queryData.page = state.queryData.page + 1;
        getAuditLogDetails({
            roleId: $scope.params.id,
            page: state.queryData.page
        });
    };

    $scope.previous = function() {
        state.queryData.page = state.queryData.page - 1;
        getAuditLogDetails({
            roleId: $scope.params.id,
            page: state.queryData.page
        });
    };
    var getDefaultDomain = function(permissionDomains) {
        state.selectedDomain = permissionDomains[0].id;
        return permissionDomains[0];
    };

    var getRoleDetails = function(request) {
        jvAdminUsersRolesService.getRole(angular.copy(request), function(data) {
            $scope.flags.loading = false;
            if (data && data.role) {
                state.role = data.role;
                massageDomains(data.role.domainPermissionTOs);
                var defaultDomain = getDefaultDomain(state.permissionDomains);
                if (defaultDomain.id === "CustomField") {
                    $scope.selectPermissionDomain(defaultDomain);
                } else {
                    state.permissionCategories = defaultDomain.permissionCategories;
                }
            }
        }, function() {
            $scope.flags.loading = false;
            $scope.$root.showMsg('UNABLE_TO_PERFORM_OPERATION', false, 'error');
        });
    };
    getRoleDetails(roleRequestObject);

    var getAuditLogDetails = function(request) {
        jvAdminUsersRolesService.getAuditLog(angular.copy(request), function(data){
            if(data && data.roleAuditLogs){
                //loalizing auditLog verb using i18n token
                angular.forEach(data.roleAuditLogs, function(auditLog) {
                    auditLog.verb = i18n[auditLog.verb];
                });
                state.total = data.count;
                state.pageSize = data.pageCount;
                state.roleAuditLogs = data.roleAuditLogs;
            }
        }, function() {
            $scope.$root.showMsg('UNABLE_TO_PERFORM_OPERATION', false, 'error');
        });
    };
    getAuditLogDetails(roleRequestObject);

  }]);
